export enum ThemeKey {
  OSP_LIGHT = 'osp-light',
  OSP_DARK = 'osp-dark',
  WACKER_NEUSON_LIGHT = 'EquipCare-Light',
  WACKER_NEUSON_DARK = 'EquipCare-Dark',
}
